export default "__VITE_ASSET__UIXDNOcE__"